// React dependencies
import React, { useEffect, useState } from 'react';

// External dependencies
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import { connect } from 'react-redux';

// Internal dependencies
import { getThumbnailFromVideoURL, datePeriodToString } from '../../../common/util';
import { IsEmpty } from '../../../common/checks';
import Colours from '../../../styles/colours';
import MText from '../../../components/Common/MText';

const Preview = (props) => {
  const [cover, setCover] = useState('');
  const [promoDate, setPromoDate] = useState('');

  useEffect(() => {
    if (!IsEmpty(props.post)) {
      if (!IsEmpty(props.post.videos)) {
        setCover(props.post.videos[0]);
      } else if (!IsEmpty(props.post.images)) {
        setCover(props.post.images[0].display);
      } else {
        setCover('');
      }

      if (!IsEmpty(props.post.promoFromDate) && !IsEmpty(props.post.promoTillDate)) {
        const formatDate = datePeriodToString(props.post.promoFromDate, props.post.promoTillDate);
        if (!IsEmpty(formatDate)) {
          setPromoDate(formatDate);
        } else {
          setPromoDate('');
        }
      } else {
        setPromoDate('Period unspecified');
      }
    }
  }, [props.post]);

  const cloudfrontUrl = 'https://d1aq8vpj94zs31.cloudfront.net/';
  const videoUrl = String(props.post.videos);
  const s3Key = videoUrl.substring(cloudfrontUrl.length);
  const thumbnailUrl = `${(`${cloudfrontUrl}thumbnails/${s3Key}`).substring(0, (`${cloudfrontUrl}thumbnails/${s3Key}`).length - 3)}jpg`;

  return (
    <div className="flex-fill d-flex flex-column justify-content-start align-items-center" style={{ height: '80dvh', paddingBottom: 30, marginRight: 10 }}>
      {!props.slidePreview && (
        <div>
          <MText size={10} colour={Colours.Gray}>Post Preview</MText>
        </div>
      )}

      <div
        className="flex-fill w-100 d-flex flex-column justify-content-start px-2"
        style={{ overflowY: 'auto', scrollbarWidth: 'none',  background: Colours.White, marginTop: 10, paddingBottom: 50, borderRadius: 10, borderWidth: 1, borderStyle: 'solid', borderColor: Colours.Gray3, position: 'relative' }}
      >
        <div className="row">
          <div className="col-md-12 p-0 m-0">
            { IsEmpty(props.post.images) && !IsEmpty(props.post.videos) && (
              <>
                <div style={{
                  width:       '100%',
                  aspectRatio: '1 / 1',
                }}
                >
                  <ReactPlayer
                    url={cover}
                    light={thumbnailUrl}
                    muted
                    playing
                    width="100%"
                    height="100%"
                  />
                </div>
              </>
            ) }

            {
              IsEmpty(props.post.videos) && !IsEmpty(props.post.images) && (
                <img src={cover} style={{ display: 'block', width: '100%', height: '100%' }} alt="" />
              )
            }

            {
              !IsEmpty(props.post.videos) && !IsEmpty(props.post.images) && (
                <img src={getThumbnailFromVideoURL(props.post.videos[0])} style={{ display: 'block', width: '100%', height: '100%' }} alt="" />
              )
            }
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 py-3 d-flex flex-column align-items-start">
            {props.page.name && (
              <div
                style={{
                  border:       `1px solid ${Colours.Gray1}`,
                  padding:      '5px 10px',
                  borderRadius: 15,
                }}
              >
                <MText
                  size={11}
                  medium
                  colour={Colours.Gray1}
                  text={props.page.name}
                />
              </div>
            ) }

            <div className="row mt-3">
              <div className="col-md-12">
                <MText semibold size={12} text={props.post.title || ''} style={{ lineHeight: '0.8rem' }} />
              </div>

              <div className="col-md-12">
                <MText size={10}>
                  {promoDate}
                </MText>
              </div>

              <div className="col-md-12 mt-2">
                <MText size={11} style={{ whiteSpace: 'pre-line' }}>
                  {props.post.description || ''}
                </MText>
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

Preview.defaultProps = {
  slidePreview: false,

  business: {
    name: '',
  },

  page: {
    name: '',
  },

  post: {
    images: [],
    videos: [],
  },
};

Preview.propTypes = {
  slidePreview: PropTypes.bool,

  business: PropTypes.shape({
    name: PropTypes.string,
  }),

  page: PropTypes.shape({
    name: PropTypes.string,
  }),

  post: PropTypes.shape({
    title:         PropTypes.string,
    description:   PropTypes.string,
    promoFromDate: PropTypes.string,
    promoTillDate: PropTypes.string,
    images:        PropTypes.arrayOf(
      PropTypes.shape({
        display:  PropTypes.string,
        original: PropTypes.string,
      }),
    ),

    videos: PropTypes.arrayOf(PropTypes.string),
  }),
};

const mapStateToProps = (state) => ({
  post: state.post.selected,
  page: state.page.selected,
});

export default connect(mapStateToProps, null)(Preview);
